import { ReactNode, Suspense } from "react";
import { Outlet, useLocation } from "react-router";

import { ChunkLoadErrorBoundary } from "@shared/ChunkLoadErrorBoundary";
import { LoadingBox } from "@shared/Loading";
import { TechnicalDifficultiesFallback } from "@shared/TechnicalDifficultiesFallback";

type Props = {
    children?: ReactNode;
};

export const PageSuspense = (props: Props) => {
    const location = useLocation();

    return (
        <ChunkLoadErrorBoundary fallback={<TechnicalDifficultiesFallback />} resetKey={location.pathname}>
            <Suspense fallback={<LoadingBox size="page" />}>{props.children ?? <Outlet />}</Suspense>
        </ChunkLoadErrorBoundary>
    );
};
